export default __webpack_public_path__ + "static/media/Territory_T.31901376.svg";